import { useEffect } from "react";

/** Route for /silent-renew.html */
const SilentRenew = () => {
  useEffect(() => {
    // check if the silent renew page is opened in an IFrame
    if (window.self !== window.top) {
      // inform the parent window with the token
      window.parent.postMessage(
        {
          source: "oidc-client",
          url: window.location.href,
        },
        window.location.origin
      );
    }
  }, []);

  return <div>SilentRenew</div>;
}

export default SilentRenew;